export enum EPostbackCurrency {
	Dollar = 'usd',
	Euro = 'eur',
}

export const POSTBACK_CURRENCY_LABEL_MAP: Record<EPostbackCurrency, string> = {
	[EPostbackCurrency.Dollar]: `postback_currency.${EPostbackCurrency.Dollar}`,
	[EPostbackCurrency.Euro]: `postback_currency.${EPostbackCurrency.Euro}`
}